import React from 'react';
import { FairnessFormGroup } from '@pascal/pascal-core';
import { AboutHash } from '../aboutHashComp/aboutHash';

export function FairnessPopup() {
  return (
    <div className='c-m-game-fairness'>
      <AboutHash />
      <FairnessFormGroup />
    </div>
  );
}
